const EnumStatusAtualizacaoPrestador = {
    PENDENTE: 'PENDENTE',
    AGUARDANDO: 'AGUARDANDO',
    CONCLUIDO: 'CONCLUIDO'
}
export default EnumStatusAtualizacaoPrestador;
